(function () {
  const stage = document.getElementById('stage');
  const bg    = document.getElementById('bg');
  const c1    = document.getElementById('cloud1');
  const c2    = document.getElementById('cloud2');
  const c3    = document.getElementById('cloud3');

  // Each layer carries its base orientation transform; scroll adds drift.
  const baseT = {
    c1: '',
    c2: 'scaleX(-1)',
    c3: 'scale(-1, -1)'
  };

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  let ticking = false;

  function update() {
    ticking = false;

    const rect = stage.getBoundingClientRect();
    const vh = window.innerHeight;
    const scrollable = stage.offsetHeight - vh;
    const scrolled = clamp(-rect.top, 0, scrollable);
    const p = scrollable > 0 ? scrolled / scrollable : 0; // 0 → 1

    // --- per-layer opacities (initial baseline × scroll falloff) ---
    const o1 = 0.95 * (1 - easeOutCubic(clamp(p / 0.80, 0, 1)));
    const o2 = 0.85 * (1 - easeInOutCubic(clamp((p - 0.08) / 0.72, 0, 1)));
    const o3 = 0.70 * (1 - easeOutCubic(clamp((p - 0.18) / 0.72, 0, 1)));

    c1.style.opacity = o1.toFixed(3);
    c2.style.opacity = o2.toFixed(3);
    c3.style.opacity = o3.toFixed(3);

    // --- gentle drift, each layer at its own speed/direction ---
    const dy1 = p * -30;
    const dx2 = p *  44;
    const dy2 = p * -70;
    const dx3 = p * -60;
    const dy3 = p * -130;

    c1.style.transform = `${baseT.c1} translate3d(0, ${dy1}px, 0)`.trim();
    c2.style.transform = `translate3d(${dx2}px, ${dy2}px, 0) ${baseT.c2}`;
    c3.style.transform = `translate3d(${dx3}px, ${dy3}px, 0) ${baseT.c3}`;

    // --- photo recovers clarity as clouds dissipate (filter only,
    //     no transform — avoids resampling moiré on fine vertical detail) ---
    const sat = 0.95 + p * 0.18;
    const bri = 0.96 + p * 0.06;
    bg.style.filter = `saturate(${sat.toFixed(2)}) brightness(${bri.toFixed(2)})`;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReduced) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  update();


  //var htracksnaps = Array(document.querySelectorAll('#hscroll article').length).keys().toArray().map(i => (1/ (document.querySelectorAll('#hscroll article').length-1))*(i));
  var htracksnaps = createArray(document.querySelectorAll('#hscroll article').length).map(i => (1/ (document.querySelectorAll('#hscroll article').length-1))*(i));

  var htrackScroll = gsap.timeline({
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger:'#hscroll',
      start: "top -50%",
      end: "bottom 130%",
      scrub: 0.1,
      ease: 'linear',
      /*snap: {
        snapTo: 'labels'
      }*/
    snap: (value) => {
        //const snapPoints = [0, 0.5, 1];
        const snapPoints = htracksnaps;
        const proximity = 0.15;

        for (let i = 0; i < snapPoints.length; i++) {
          if (value > snapPoints[i] - proximity && value < snapPoints[i] + proximity) {
            return snapPoints[i];
          }
        }
      },
      onUpdate: function(s) {
        let currind = 0;
        for(var i = 0; i < htracksnaps.length; i++) {
          if(s.progress >= htracksnaps[i] - 0.1)
            currind = i;
        }
        document.querySelector('#hprogress .dot.is-active')?.classList.remove('is-active');
        document.querySelectorAll('#hprogress .dot')[currind].classList.add('is-active');
      }
    }
  });

  let totPerc = 100 * (document.querySelectorAll('#hscroll article').length - 1);
  for(let i = 1; i < htracksnaps.length; i++) {
    htrackScroll.addLabel('htrackslide'+(i-1));
    htrackScroll.to("#htrack", {
      transform: "translateX(-"+(totPerc * htracksnaps[i])+"vw)"
    });
  }
  htrackScroll.addLabel('htrackslide'+(htracksnaps.length - 1))
  /*var htrackScroll = gsap.to("#htrack", {
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger:'#hscroll',
      start: "top -50%",
      end: "bottom 130%",
      scrub: 0.1,
      //snap: 1 / (document.querySelectorAll('#hscroll article').length - 1)
      snap: (value) => {
        //const snapPoints = [0, 0.5, 1];
        const snapPoints = htracksnaps;
        const proximity = 0.15;

        for (let i = 0; i < snapPoints.length; i++) {
          if (value > snapPoints[i] - proximity && value < snapPoints[i] + proximity) {
            return snapPoints[i];
          }
        }
      },
      onUpdate: function(s) {
        //console.log('prog', s)
        let currind = 0;
        for(var i = 0; i < htracksnaps.length; i++) {
          if(s.progress >= htracksnaps[i] - 0.1)
            currind = i;
        }
        document.querySelector('#hprogress .dot.is-active')?.classList.remove('is-active');
        document.querySelectorAll('#hprogress .dot')[currind].classList.add('is-active');
      }
    },
    ease: 'linear',
    transform: "translateX(-"+(100 * (document.querySelectorAll('#hscroll article').length - 1))+"vw)",
  });*/

  document.querySelector('#hprogress').addEventListener('click', function(e) {
    let index = Array.from(document.querySelectorAll("#hprogress .dot")).indexOf(e.target);
    console.log('scrollto', htrackScroll.scrollTrigger.labelToScroll('htrackslide'+(index)));
    
    let scrollPos = labelToScroll(htrackScroll, 'htrackslide'+(index));
    //gsap.to(window, { scrollTo: scrollPos });
    window.scrollTo({
      top: scrollPos,
      behavior: "smooth",
    });

    /*console.log('click ind', htrackScroll)
    gsap.to("#htrack", {
      transform: "translateX(-"+(100 * htracksnaps[index] * (document.querySelectorAll('#hscroll article').length - 1))+"vw)",
    });*/
    //document.querySelector('#hprogress .dot.is-active')?.classList.remove('is-active');
    //document.querySelectorAll('#hprogress .dot')[index].classList.add('is-active');
  });

  function labelToScroll(timeline, label) {
    let st = timeline.scrollTrigger;
    return st.start + (st.end - st.start) * (timeline.labels[label] / timeline.duration());
  }

  window.addEventListener("resize", function() {
    console.log('recalculate')
    ScrollTrigger.refresh();
  });

  const sustainability = document.getElementById('sustainability');
  const sustainabilityDetails = Array.from(sustainability.querySelectorAll('details'));

  function updateSustainability(detail) {
    sustainability.querySelector('#accIndex .cur').textContent = (sustainabilityDetails.indexOf(detail) + 1).toString().padStart(2, '0');
    sustainability.querySelector('.sustain-bg').style.backgroundImage = 'url('+detail.dataset.bg+')';
  }

  sustainabilityDetails.forEach((detail) => {
    detail.addEventListener("toggle", (event) => {
      if (event.target.open) {
        updateSustainability(event.target);
        /* the element was toggled open */
      } else {
        document.querySelector('.sustain-bg-fading').style.backgroundImage = 'url('+event.target.dataset.bg+')';
        gsap.fromTo('.sustain-bg-fading', {
          opacity: 1,
        }, {
          opacity: 0,
          duration: 0.5,
        });
        /* the element was toggled closed */
      }
    });
  });

  function openSustainabilityFromHash() {
    let anchor;
    try {
      anchor = decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return;
    }

    const detail = sustainabilityDetails.find((item) => item.id === anchor);
    if (!detail) return;

    sustainabilityDetails.forEach((item) => {
      if (item !== detail) item.open = false;
    });
    detail.open = true;
    updateSustainability(detail);

    // Recalculate the scroll animations after opening, then show the section.
    requestAnimationFrame(() => {
      ScrollTrigger.refresh();
      sustainability.scrollIntoView({ behavior: 'instant', block: 'start' });
    });
  }

  window.addEventListener('hashchange', openSustainabilityFromHash);
  if (document.readyState !== 'complete') {
    // Images and videos above the accordion can still change its position.
    window.addEventListener('load', openSustainabilityFromHash, { once: true });
  }
  openSustainabilityFromHash();

  function createArray(len) {
    let arr = new Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = i;
    }
    return arr;
  }
})();
